module.exports = global["Tether"] = require("-!/home/web/aio/www/themes/aio/_dev/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use!./tether.js");